import "./CardList.scss";

import { Card, CardBody, CardFooter, CardHeader, Flex } from "@fluentui/react-northstar";
import React, { useMemo } from "react";

import { useTeamsContext } from "../../../_shared/state/TeamsContextProvider";
import { isMobileClient } from "../../../_shared/utils/clientHelper";

type CardItem = {
  key: string;
  className?: string;
  body?: JSX.Element;
  header?: JSX.Element;
  footer?: JSX.Element;
  onClicked?: () => void;
};

type Props = {
  items: CardItem[];
  alignItems?: "flex-start" | "center";
};

export const CardList: React.FC<Props> = ({ items, alignItems }) => {
  const { teamsContext } = useTeamsContext();
  const isMobile = isMobileClient(teamsContext);

  const computedItems = useMemo(() => {
    if (isMobile) {
      return items;
    }

    const ci = [...items];
    while (ci.length % 3 !== 0) {
      ci.push({ key: `empty-${ci.length}` });
    }
    return ci;
  }, [items, isMobile]);

  return (
    <div className="card-list">
      <Flex className="card-list-box" wrap={!isMobile} column={isMobile} space="evenly">
        {computedItems.map(item => (
          <Card
            className={`card-list-box-item card-list-box-item-${isMobile ? "mobile" : "desktop"} ${
              item.className ?? ""
            }`}
            key={item.key}
            fluid={isMobile}
            style={{
              visibility: item.key.startsWith("empty-") ? "hidden" : undefined,
              alignItems: alignItems,
            }}
            centered
            onClick={item.onClicked}
          >
            {item.header && <CardHeader styles={{ width: "100%" }}>{item.header}</CardHeader>}
            <CardBody className="card-list-box-item-body">{item.body}</CardBody>
            {item.footer && <CardFooter>{item.footer}</CardFooter>}
          </Card>
        ))}
      </Flex>
    </div>
  );
};
